import React, { useMemo } from "react";
import useFetchQCMetrics from "../Hooks/QC/useFetchQCMetrics";
import { useParams } from "react-router-dom";
import { CSVLink } from "react-csv";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import processDataQcReport from "./reportUtils/processDataQcReport";
import { isObjectEmptyNull, formatValue } from "../../utils/basic";
import Spinner from "../common/Spinner";
import Download2Pdf from "../common/Download2Pdf";
import { getCurrentDateTime } from "../../utils/basic";


const QCMetricsReport = () => {

    const { plate_uuid, platename } = useParams();
    const metrics = useFetchQCMetrics(plate_uuid);

    const apiData = metrics?.isSuccess ? metrics?.data : [];
    const apiDataForProcessing = Object.entries(apiData);

    const { mainStatsData, additionalStats } = useMemo(() => processDataQcReport(apiDataForProcessing), [apiDataForProcessing, metrics?.isLoading]);


    // Combine both arrays to generate the CSV
    const combinedData = metrics?.isSuccess && !isObjectEmptyNull(mainStatsData) ? [...mainStatsData, ...additionalStats] : [];
    const currentDateTime = getCurrentDateTime();

    // Prepare CSV headers
    const headers = [
        {
            label: `Date: ${currentDateTime}`, // Insert date into the label
            key: "date" // Optional key for sorting, if needed 
        },
        { label: "Statistic", key: "Statistic" },
        { label: "Specification", key: "Specification" },
        { label: "Observed Value", key: "ObservedValue" },
        { label: "Pass/Fail", key: "passfailValue" }
    ];

    const csvReport = {
        filename: `${plate_uuid}.csv`,
        headers: headers,
        data: combinedData
    };

    if (metrics?.isLoading) {
        // Data is still loading, return a spinner
        return <Spinner text="Fetching Data.. Please wait"></Spinner>;
    }
    // the email id solution is a temp one - will be doing a generalized comp for slack feedback later 
    if (isObjectEmptyNull(mainStatsData)) {
        return <div className="flex px-16 py-16 justify-center items-center" >
            <p className="text-red-600 font-bold">Incorrect Data Format or Older Plate Data. Please contact the  Application Team at <span className="text-blue-500">one_tool_support@bio-rad.com</span></p>
        </div>
    }

    return (
        // 
        <>

            <div className="flex items-end p-5">
                <div className="flex-grow"></div>
                <Download2Pdf reportData={combinedData} reportType="fixedCol" />
                <span className="p-2"> </span>
                <CSVLink
                    {...csvReport}// this will be the file name
                    className="text-center p-1 border border-custom-green rounded-[8px] bg-custom-green
                 text-white text-xs font-semibold leading-snug uppercase tracking-wider"
                >
                    <CloudDownloadIcon fontSize="small" /> CSV
                </CSVLink>
            </div>

            {metrics?.isSuccess ? (
                <div className="flex justify-center flex-grow min-h-screen border-2 border-solid">
                    <div className="flex flex-col gap-1 w-full">
                        <h2 className="pt-10 text-center font-bold text-custom-green uppercase">Specifications</h2>
                        <h4 className="pt-3 text-center font-bold text-custom-green uppercase">Plate Name : {platename}</h4>
                        <h4 className="pt-3 text-center font-bold text-custom-green uppercase">Date : {currentDateTime}</h4>
                        <div className=" flex gap-1 pl-10 pr-10 w-full">

                            <div className="rounded-xl w-full">
                                <table className=" border-collapse table-auto w-full text-md">
                                    <thead className="sticky top-0">
                                        <tr>
                                            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-bold
                                             text-custom-green uppercase tracking-wider">Statistic</th>
                                            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-bold
                                              text-custom-green uppercase tracking-wider">Specification</th>
                                            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-bold  text-custom-green uppercase tracking-wider">Observed Value</th>
                                            {/* <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-bold  text-custom-green uppercase tracking-wider">Result</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {mainStatsData?.map((item, index) => (
                                            <tr key={index} className={item?.pass ? 'pass' : ''}>
                                                <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs 
                                            font-semibold leading-snug text-gray-600 uppercase tracking-wider" >{item?.Statistic}</td>
                                                <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs 
                                            font-semibold leading-snug text-gray-600 uppercase tracking-wider">{item?.Specification}</td>
                                                <td className={`px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left 
                                                text-xs font-semibold leading-snug text-gray-600 tracking-wider ${item?.passfailValue === 'Pass' ? 'pass' : item?.passfailValue === 'Fail' ? 'fail' : ''} `} >{formatValue(item?.ObservedValue)}</td>
                                                {/* <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs 
                                            font-semibold text-gray-600 uppercase tracking-wider" >{item?.pass}</td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="flex flex-col gap-2 pl-10 pr-10 w-full">
                            <h2 className="text-center font-bold text-custom-green uppercase">Additional Statistics</h2>
                            <div className="relative rounded-xl w-full">

                                <table className="border-collapse w-full table-auto text-md">

                                    <thead className="sticky top-0">
                                        <tr>
                                            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs
                                            font-bold text-custom-green uppercase tracking-wider">Statistic</th>
                                            <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs 
                                            font-bold text-custom-green uppercase tracking-wider">Observed Value</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {additionalStats.map((item, index) => (
                                            <tr key={index} className={item?.pass ? 'pass' : ''}>
                                                <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs
                                            font-semibold text-gray-600 uppercase tracking-wider">{item?.Statistic}</td>
                                                <td className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs
                                            font-semibold text-gray-600 uppercase tracking-wider">{item?.ObservedValue}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div >
            ) : metrics?.isError ? (
                <div className="flex flex-col items-center  max-h-[80vh] overflow-x-auto overflow-y-scroll">
                    <h2 className="text-red-600"> "Fetchin Data Error... please try later"</h2>
                </div>
            ) : <div className="text-red-600">Data Error</div>}

        </>
    );

};

export default QCMetricsReport;

